import React from 'react'
import { Link } from 'react-router-dom'

function LandingPage() {
  function colourise(e) {
    e.target.style.color = 'orangered';
  }

  function decolourise(e) {
    e.target.style.color = 'darkgray';
  }

  return (
    <div className="landing-menu">
      <Link to="/creating">
        <h1 onMouseEnter={colourise} onMouseLeave={decolourise}>CREATING</h1>
      </Link>
      <Link to="/coaching">
        <h1 onMouseEnter={colourise} onMouseLeave={decolourise}>COACHING</h1>
      </Link>
    </div>
  )
}

export default LandingPage
